// extracted by mini-css-extract-plugin
export default {"button":"SearchModal_button__LBVOv","button_close":"SearchModal_button_close__qzRFB"};